// import Bugsnag from '@bugsnag/expo';
// Bugsnag.start();

import React, { useState, useEffect } from 'react';
import { StyleSheet, Text, View, Dimensions, Platform } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import * as Font from 'expo-font';
import { store } from './src/store/store';
import { Provider, useSelector } from 'react-redux';
import Router from './src/components/Router';
import {
  SafeAreaView,
  SafeAreaProvider,
  SafeAreaInsetsContext,
  useSafeAreaInsets,
  initialWindowMetrics,
} from 'react-native-safe-area-context';
import FocusCheck from './src/components/FocusCheck';
import { focusHelper } from './src/functions/focusHelper';
import Bugsnag from '@bugsnag/expo';
import ForceUpdateHandler from './src/components/ForceUpdateHandler';

function App() {
  const [isReady, setIsReady] = useState(false);
  Bugsnag.start();

  useEffect(() => {
    async function loadFonts() {
      await Font.loadAsync({
        'Montserrat-RG': require('./assets/fonts/Montserrat-Regular.ttf'),
        'Montserrat-SB': require('./assets/fonts/Montserrat-SemiBold.ttf'),
        'Montserrat-EB': require('./assets/fonts/Montserrat-ExtraBold.ttf'),
        'Montserrat-MED': require('./assets/fonts/Montserrat-Medium.ttf'),
        'Montserrat-BK': require('./assets/fonts/Montserrat-Black.ttf'),
        'PresicavHv-RG': require('./assets/fonts/PresicavHv-Regular.ttf'),
        'PresicavLt-BD': require('./assets/fonts/PresicavLt-Regular.ttf'),
        'PresicavRb-RG': require('./assets/fonts/PresicavRg-Bold.ttf'),
        'PresicavRg-RG': require('./assets/fonts/PresicavRg-Regular.ttf'),
        'PresicavUI-RG': require('./assets/fonts/PresicavUl-Regular.ttf'),
        'PresicavXI-RG': require('./assets/fonts/PresicavXl-Regular.ttf'),
      });
      setIsReady(true);
    }

    loadFonts();
  }, []);

  if (!isReady) {
    return (
      <View style={styles.container}>
        <Text>Loading...</Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      {Platform.OS !== "web" && (
        <ForceUpdateHandler />
      )}
      <Router />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: 0,
    margin: 0,
    width: '100%',
    height: '100%',
    background: 'white',
  },
});

export default () => {
  return (
    <Provider store={store}>
      {Platform.OS !== "web" && (
        <FocusCheck focusHelper={focusHelper} />
      )}
      <App />
    </Provider>
  );
};
